import React, { useState, useCallback } from 'react';
import { FormattedMessage } from 'react-intl';

import { INLINE_MESSAGE_TYPES } from 'ui-components/components/inline-message';

import { ShipFromContactDropdown } from '../../../../carrier-pickup/modal-components/shipfrom-contact-dropdown';
import { usePickupSettingsContext, usePickupSettingsContextTypes } from '../contexts/pickup-settings-context';

import messages from '../messages';
import style from '../style.module.less';
import classnames from 'classnames';

const ShipFromContact = () => {
  usePickupSettingsContextTypes('ShipFromContact');
  const { shipFrom, selectedContact, onSelectContact, contacts, validationErrors, refreshContactList } = usePickupSettingsContext();
  const errorDescriptor = validationErrors[0]?.shipFromContactId?.message;
  const [isTouched, setIsTouched] = useState(false);
  const onBlur = useCallback(() => setIsTouched(true), []);
  const hasError = isTouched && !!errorDescriptor;
  return (
    <div className={classnames(style['input-section-wrapper'], style['pickup-contact-wrapper'])}>
      <label className={classnames(style.label, { [style.error]: hasError })}>
        <FormattedMessage {...messages.pickupContact} />
      </label>
      <ShipFromContactDropdown
        className={style['full-row-dd']}
        contacts={contacts}
        errorDescriptor={errorDescriptor}
        hasError={hasError}
        inlineMessage={hasError ? <FormattedMessage {...errorDescriptor} /> : undefined}
        inlineMessageType={hasError ? INLINE_MESSAGE_TYPES.error : undefined}
        onBlur={onBlur}
        onContactEdited={refreshContactList}
        onContactRemoved={refreshContactList}
        onContactSelected={onSelectContact}
        selectedContactId={selectedContact?.shipFromContactId}
        shipFromId={shipFrom.shipFromId}
        variant='form'
      />
    </div>
  );
};

export default ShipFromContact;
